<div class="row">
  <div class="container-message">
    <div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title" class="custom-title">
      {{ title }}
    </div>
    <div
      *ngIf="message && options.enableHtml"
      role="alertdialog"
      aria-live="polite"
      class="custom-message"
      [ngClass]="options.messageClass"
      [innerHTML]="message"
    ></div>
    <div
      *ngIf="message && !options.enableHtml"
      role="alertdialog"
      aria-live="polite"
      class="custom-message"
      [ngClass]="options.messageClass"
      [attr.aria-label]="message"
    >
      {{ message }}
    </div>
  </div>
  <div class="text-right">
    <button *ngIf="options.closeButton" (click)="remove()" class="close-button" aria-label="Close" mat-icon-button>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
